<template>

  <base-modal name="mediacontact-product-type-create"
              title="Produktart erstellen"
              :width="400"
              v-on="$listeners"
              v-bind="$attrs">
    <mediacontact-product-type-form :mediacontactProductType="mediacontactProductType" type="create"/>
  </base-modal>

</template>

<script>
import MediacontactProductTypeForm from './MediacontactProductTypeForm.vue'

export default {
  name: 'MediacontactProductTypeCreate',
  components: { MediacontactProductTypeForm },
  data: () => ({
    mediacontactProductType: {
      name: null
    }
  })
}
</script>
